import React from "react";

type Size = {
  width: number;
  height: number;
};
type ThumbnailProps = {
  height: number;
  width: number;
  imageSrc: string;
  size: Size;
  onClick: (...args: any[]) => any;
  selected: boolean;
};
export class Thumbnail extends React.Component<ThumbnailProps, {}> {
  public render() {
    const { imageSrc } = this.props;
    let style = {};
    if (this.props.selected) {
      style = {
        borderStyle: "solid",
        borderColor: "red",
        borderWidth: "2px",
      };
    }
    return (
      <div style={style} className="thumbnail">
        <img
          alt="Thumbnail"
          onClick={this.props.onClick}
          width="100%"
          src={imageSrc}
        />
      </div>
    );
  }
}
